@if(isReady){
  <lib-app-shell [application]="frameworkService.currentApp" (quickActionItemClicked)="onQuickActionItemClicked($event)" (addQuickActionClicked)="onAddQuickActionClicked()" />
} @else{
  <div class="loading-container">
    <h2>Loading Benzaiten...</h2>
  </div>
}
<app-default-modal [level]="1" class="l1"></app-default-modal>
<optima-toast-container></optima-toast-container>
<app-off-canvas-collective></app-off-canvas-collective>
<lib-entity-bottom-off-canvas-outlet />